module.exports = __webpack_public_path__ + "img/24.d7f1b0ca.png";